// extracted by mini-css-extract-plugin
export default {"pageCenter":"pageLoading_pageCenter__zQoJx","loader":"pageLoading_loader__XEO8+","spin988":"pageLoading_spin988__-mWSv","circle":"pageLoading_circle__Y9Tae"};